import React from 'react';
import { VideoData } from 'types/video-data';
import ReactPlayer from 'react-player';

/**
 * ReactPlayer: https://www.npmjs.com/package/react-player
 * @param VideoData 
 * @returns 
 */
const VideoEmbed: React.FC<VideoData> = ({ url, title }) => {
    return (
        <div className="react-player-wrapper">
            <ReactPlayer
                className='react-player'
                url={url}
                width={'100%'}
                height={'100%'}
                controls
                config={{
                    youtube: {
                        playerVars: { showinfo: 1 }
                    },
                    vimeo: {
                        title: title
                    }
                }}
            />
        </div>
    );
};

export default VideoEmbed;